import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@doger/ui/components/ui/dialog';

import { LogAmplitudeEventOnMount } from '@doger/chat/shared/analytics';

import { useAuth } from '../auth.context';
import { ApplyForAnWhitelistForm } from './apply-for-an-whitelist-form.component';
import styles from './apply-for-an-whitelist-modal.module.scss';

export const ApplyForAnWhitelistModal = memo(() => {
  const { isWhitelistModalOpen, setIsWhitelistModalOpen } = useAuth();
  const { t } = useTranslation();

  const onClose = useCallback(() => {
    setIsWhitelistModalOpen(false);
  }, [setIsWhitelistModalOpen]);

  const onSuccess = useCallback(() => {
    setIsWhitelistModalOpen(false);
  }, [setIsWhitelistModalOpen]);

  return (
    <Dialog open={isWhitelistModalOpen} onOpenChange={onClose}>
      <DialogContent className={styles.modal}>
        <LogAmplitudeEventOnMount event='Whitelist Modal Viewed' />

        <DialogHeader className={styles.header}>
          <DialogTitle>{t('whitelist.application.title')}</DialogTitle>
          <DialogDescription>
            {t('whitelist.application.description')}
          </DialogDescription>
        </DialogHeader>

        <DialogBody>
          <ApplyForAnWhitelistForm onSuccess={onSuccess} />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
});
